import { z } from 'zod';
import { IdempotencyKeySchema } from './common.js';

export const QuestCompleteRequestSchema = z.object({
  questId: z.string().min(1),
  idempotencyKey: IdempotencyKeySchema,
});
export type QuestCompleteRequest = z.infer<typeof QuestCompleteRequestSchema>;

export const QuestCompleteResponseSchema = z.object({
  questId: z.string().min(1),
  rewardZl: z.number().int().nonnegative(),
  balance: z.number().int().nonnegative(),
});
export type QuestCompleteResponse = z.infer<typeof QuestCompleteResponseSchema>;

/**
 * Kody błędów endpointu misji (mapowane na ErrorCode / HTTP):
 * - VALIDATION (400) — zły body
 * - UNAUTHORIZED (401) — brak sesji
 * - NOT_FOUND (404) — nieznany questId
 * - RATE_LIMITED (429) — cap 5 misji / dzień UTC
 * - CONFLICT (409) — obcy idempotency_key
 * - INTERNAL (500)
 */
export const QuestErrorCodes = [
  'VALIDATION',
  'UNAUTHORIZED',
  'NOT_FOUND',
  'RATE_LIMITED',
  'CONFLICT',
  'INTERNAL',
] as const;
export type QuestErrorCode = (typeof QuestErrorCodes)[number];
